<template>
  <div class="beizhuMarkBox" custom-class="el-dialog--center">
    <!-- 备注运、单 -->
    <el-dialog title="记录备注" :before-close="closeDialog" :visible.sync="beizhuMark" :close-on-click-modal="false" width="600px" center>
      <el-form :rules="rules" :model="beizhuForm" ref="beizhuForm" label-width="120px" size="mini">
        <div class="jiaoyan">
          <el-form-item label="备注">
            <el-input type="textarea" :rows="4" style="width: 350px; vertical-align: top" placeholder="限制120个字" maxlength="120" v-model="beizhuForm.recordRemark"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin: 15px auto" class="el-dialog--center">
        <el-button @click="addNo">取消</el-button>
        <el-button type="primary" @click="addOk('beizhuForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { operationChangeRecordRemarks, operationOutStockRecordRemarks } from '@/api/wms-stock'

export default {
  data () {
    return {
      rules: {
        recordRemark: [
          { required: true, message: '请输入备注', trigger: ['blur', 'change'] }
        ]
      },
      tableList: [],
      beizhuForm: {},
      selection: []
    }
  },
  props: {
    beizhuMark: {
      type: Boolean,
      default: false
    },
    selectId: {
      type: Array
    },
    beizhuName: {
      type: String
    }
  },
  created () {
  },
  methods: {
    closeDialog () {
      this.$emit('update:beizhuMark', false)
    },
    addNo () {
      this.$emit('update:beizhuMark', false)
    },
    addOk (formName) {
      console.log(this.beizhuName, 'beizhuName')
      if (this.beizhuName == '转货记录JF') {
        this.jianfaZH()
      } else if (this.beizhuName == '转货记录YYC') { this.YYCZH() } else if (this.beizhuName == '出库记录JF') { this.jianfaCK() } else if (this.beizhuName == '出库记录YYC') { this.YYCCK() }
    },
    jianfaZH () {
      let that = this
      const loading = that.$loading({
        lock: true,
        text: '正在处理...'
      })
      operationChangeRecordRemarks({
        changeDetailIds: this.selectId, // （数组形式）
        recordRemark: this.beizhuForm.recordRemark // 出库记录备注

      }).then(res => {
        loading.close()
        that.beizhuForm = {}
        if (that.$refs.beizhuForm !== undefined) {
          that.$refs.beizhuForm.resetFields()
        }
        that.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:beizhuMark', false)
        this.$emit('shuaxin')
      }).catch(error => {
        that.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    YYCZH () {
      let that = this
      const loading = that.$loading({
        lock: true,
        text: '正在处理...'
      })
      operationChangeRecordRemarks({
        changeDetailIds: this.selectId, // （数组形式）
        recordRemark: this.beizhuForm.recordRemark // 出库记录备注

      }).then(res => {
        loading.close()
        that.beizhuForm = {}
        if (that.$refs.beizhuForm !== undefined) {
          that.$refs.beizhuForm.resetFields()
        }
        that.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:beizhuMark', false)
        this.$emit('shuaxin')
      }).catch(error => {
        that.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    jianfaCK () {
      let that = this
      const loading = that.$loading({
        lock: true,
        text: '正在处理...'
      })
      operationOutStockRecordRemarks({
        outstockSummaryIds: this.selectId, // （数组形式）
        recordRemark: this.beizhuForm.recordRemark // 出库记录备注

      }).then(res => {
        loading.close()
        that.beizhuForm = {}
        if (that.$refs.beizhuForm !== undefined) {
          that.$refs.beizhuForm.resetFields()
        }
        that.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:beizhuMark', false)
        this.$emit('shuaxin')
      }).catch(error => {
        that.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    YYCCK () {
      let that = this
      const loading = that.$loading({
        lock: true,
        text: '正在处理...'
      })
      operationOutStockRecordRemarks({
        outstockSummaryIds: this.selectId, // （数组形式）
        recordRemark: this.beizhuForm.recordRemark // 出库记录备注

      }).then(res => {
        loading.close()
        that.beizhuForm = {}
        if (that.$refs.beizhuForm !== undefined) {
          that.$refs.beizhuForm.resetFields()
        }
        that.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:beizhuMark', false)
        this.$emit('shuaxin')
      }).catch(error => {
        that.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }

  }
}
</script>

  <style  scoped lang='less'>
.jiaoyan {
  /deep/ .el-input {
    width: 180px;
  }
  /deep/.el-input__inner {
    width: 180px;
  }
  /deep/.el-form-item {
    margin-bottom: 22px;
  }
}
</style>
